export default "__VITE_ASSET__86M8cQJY__"